export default __webpack_public_path__ + "media/titles/title_1_locale_pt-d864a64b.png";